import { CULTURE_DAILY_MISSIONS } from './collectorCultureSystem';
import { collectorCultureService } from '../services/collectorCultureService';

const missionConfig = Object.fromEntries(
  CULTURE_DAILY_MISSIONS.map((m) => [m.key, { xp: m.xp, target: m.target }]),
) as Record<string, { xp: number; target: number }>;

/** Record real culture mission progress (server-side daily caps). */
export async function trackCultureMission(missionKey: string, increment = 1) {
  const cfg = missionConfig[missionKey];
  if (!cfg) return null;
  const { data, error } = await collectorCultureService.recordMissionProgress(
    missionKey,
    increment,
    cfg.xp,
    cfg.target,
  );
  if (error) return null;
  return data;
}
